import {useQuery, UseQueryResult} from '@tanstack/react-query';
import {IFetchRoomProtection} from '../../../incase-domain/rooms/room.player';
import {fetchRoomProtection} from '../../../service/room.service';

export const roomProtectionKey = 'roomProtection';

interface IFetchRoomProtectionProps {
    roomId: string;
}

export const useFetchRoomProtection = ({roomId}: IFetchRoomProtectionProps): UseQueryResult<IFetchRoomProtection> => {
    return useQuery({
        queryKey: [roomId, roomProtectionKey],
        queryFn: () => fetchRoomProtection(roomId),
        enabled: !!roomId,
    });
};
